import React from 'react';
import {
  SolidFileDocIcon,
  SolidFileDocxIcon,
  SolidFileExcelIcon,
  SolidFileMDIcon,
  SolidFilePPTIcon,
  SolidFilePdfIcon,
  SolidFileTxtIcon,
  SolidFileFailIcon,
  SolidFileUnknowIcon,
  SolidFileTxtIconWeb,
  SolidFileDocxIconWeb,
  SolidFileExcelIconWeb,
  SolidFileMDIconWeb,
  SolidFilePdfIconWeb,
  SolidFilePPTIconWeb,
  SolidFileFailIconWeb,
} from '@whelk/assets/src/web/file-icon';
import { isWeb } from '@whelk/const/src/env';

export const getFileSvg = (suffix: string, size: number): JSX.Element => {
  const config: Record<string, JSX.Element> = {
    txt: isWeb ? <SolidFileTxtIconWeb size={size} /> : <SolidFileTxtIcon size={size} />,
    docx: <SolidFileDocxIcon size={size} />,
    doc: isWeb ? <SolidFileDocxIconWeb size={size} /> : <SolidFileDocIcon size={size} />,
    xls: isWeb ? <SolidFileExcelIconWeb size={size} /> : <SolidFileExcelIcon size={size} />,
    xlsx: isWeb ? <SolidFileExcelIconWeb size={size} /> : <SolidFileExcelIcon size={size} />,
    md: isWeb ? <SolidFileMDIconWeb size={size} /> : <SolidFileMDIcon size={size} />,
    pdf: isWeb ? <SolidFilePdfIconWeb size={size} /> : <SolidFilePdfIcon size={size} />,
    ppt: isWeb ? <SolidFilePPTIconWeb size={size} /> : <SolidFilePPTIcon size={size} />,
    pptx: isWeb ? <SolidFilePPTIconWeb size={size} /> : <SolidFilePPTIcon size={size} />,
    fail: isWeb ? <SolidFileFailIconWeb /> : <SolidFileFailIcon />,
  };

  return config[suffix] || <SolidFileUnknowIcon />;
};
